import { getPublicSettings } from '../services/settingsService';

// Una sola petición a GET /settings/public por carga de la app: el interruptor
// de registro de médicos y la tarifa de la consulta comparten la respuesta.
// Si falla se resuelve con null y se reintenta en el próximo montaje.
let cached = null;

export const fetchPublicSettings = () => {
  if (!cached) {
    cached = getPublicSettings()
      .then((s) => s || null)
      .catch(() => {
        cached = null;
        return null;
      });
  }
  return cached;
};

// Olvida la respuesta guardada: tras cambiar un ajuste en el panel, y en tests.
export const invalidatePublicSettingsCache = () => { cached = null; };
